import React, { Component } from 'react';
import { shape } from 'prop-types';
import { Button, Form, Message } from 'semantic-ui-react';

import { auth } from '../firebase';
import * as routes from '../routes.json';

const initialState = {
  email: '',
  error: null,
};

class PasswordForgetForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    const { history } = this.props;
    event.preventDefault();
    auth
      .passwordReset(this.state.email)
      .then(() => {
        this.setState(() => ({ ...initialState }));
        history.push(routes.home);
      })
      .catch(error => this.setState({ error }));
  }

  render() {
    const isInvalid = this.state.email === '';
    return (
      <Form size="large" onSubmit={this.handleSubmit}>
        <Form.Input
          icon="user"
          value={this.state.email}
          name="email"
          onChange={event => this.handleChange(event)}
          placeholder="Email Address"
          type="email"
          fluid
          iconPosition="left"
        />
        <Button
          disabled={isInvalid}
          type="submit"
          color="orange"
          fluid
          size="large"
        >
          Reset My Password
        </Button>
        {this.state.error && (
          <Message negative>{this.state.error.message}</Message>
        )}
      </Form>
    );
  }
}

PasswordForgetForm.propTypes = {
  history: shape().isRequired,
};

export default PasswordForgetForm;



// WEBPACK FOOTER //
// ./src/components/PasswordForgetForm.jsx